export default __webpack_public_path__ + "deabf6e28d330dbd25ed93637c3ea58b.png";